import { IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class TypesDTO {
    @ApiProperty()
    @IsNotEmpty({ message: "notify party id should not be empty" })
    @IsAlphanumeric()
    typeId?: number;

    @ApiProperty()
    @IsNotEmpty({ message: "notify Party Name should not be empty" })
    @IsAlphanumeric()
    @IsOptional()
    type: string;

    @ApiProperty()
    @IsNotEmpty({ message: "Item Sub Category code should not be empty" })
    itemSubCategoryId: number;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(50, { message: "Created User allows maximum 50 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    updatedAt: Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(50, { message: "Updated User allows maximum 50 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
    updatedUser: string;


    @ApiProperty()
    versionFlag: number;
}